module.exports = __webpack_public_path__ + "img/team.3440b221.svg";